// Mantiene el access token únicamente en memoria para evitar persistir credenciales sensibles.
import { publishAuthEvent, subscribeAuthEvents } from './authChannel'

let accessToken = null
let accessTokenUpdatedAt = 0

export function setAccessToken(token, { broadcast = true, updatedAt = Date.now() } = {}) {
  accessToken = token || null
  accessTokenUpdatedAt = accessToken ? updatedAt : 0

  if (accessToken && broadcast) {
    publishAuthEvent({
      type: 'TOKEN_UPDATED',
      token: accessToken,
      updatedAt: accessTokenUpdatedAt
    })
  }
}

export function getAccessToken() {
  return accessToken
}

export function clearAccessToken({ broadcast = false } = {}) {
  accessToken = null
  accessTokenUpdatedAt = 0

  if (broadcast) publishAuthEvent({ type: 'LOGOUT' })
}

subscribeAuthEvents((event) => {
  if (event?.type === 'TOKEN_REQUEST' && accessToken) {
    publishAuthEvent({
      type: 'TOKEN_RESPONSE',
      requestId: event.requestId,
      token: accessToken,
      updatedAt: accessTokenUpdatedAt
    })
    return
  }

  if (event?.type === 'TOKEN_UPDATED' && event.token && event.updatedAt >= accessTokenUpdatedAt) {
    // Todas las pestañas usan la misma generación sin recargar la pantalla.
    setAccessToken(event.token, {
      broadcast: false,
      updatedAt: event.updatedAt
    })
    return
  }

  if (event?.type === 'LOGOUT') clearAccessToken()
})
